import {Injectable} from '@angular/core';
import {ApiService} from '../../core/services/api.service';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../core/shared/classes/api';
import {Commentaire} from '../classes/commentaire';

export class CommentaireListQueries {
    page = null;
    perPage = null;
}

@Injectable()
export class CommentaireService {
    constructor(private apiService: ApiService) {}

    fetchAll(resource, resourceType, commentaireListQuery?: CommentaireListQueries): Observable<ApiResponse> {
        return this.apiService.get(`commentaire/resource/${resource}/${resourceType}`, {}, commentaireListQuery);
    }

    createCommentaire(commentaire: Commentaire): Observable<ApiResponse> {
        commentaire.com_content = JSON.stringify(commentaire.content);
        return this.apiService.post(`commentaire`, JSON.stringify(commentaire));
    }

    deleteCommentaire(commentaire: Commentaire): Observable<ApiResponse> {
        return this.apiService.delete(`commentaire/${commentaire.com_id}`);
    }
}
